<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0" class="padding10">
        <el-row>
            <el-col :span="16" class="align-left">
                <h3>第{{ h_t || '--' }}次交班</h3>
            </el-col>
            <el-col :span="8">
                <el-row type="flex" justify="end">
                    <el-col :span="16" v-if="activeHandover && activeHandover.unsaved" class="align-right">
                        <el-button type="warning" size="mini" @click="SaveChanges"><i class="el-icon-loading" v-if="!finished"></i>保存</el-button>
                        &nbsp;
                        <el-link type="warning" size="mini" @click="clearChanges">撤销修改</el-link>
                    </el-col>
                    <el-col :span="8">
                        <el-button type="primary" size="mini" @click="addNewHandover()">创建交接</el-button>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <br />
        <el-row>
            <el-col :span="24">
                <el-form ref="form-worker" :inline="true" size="mini" class="align-left" label-position="left">
                    <el-form-item label="时间:" style="line-height: 38px">
                        <item-input style="width: 160px" type="datetime" :noPadding="true" datetimeFormate="yyyy/MM/dd HH:mm" v-model="shift_time" placeholder="交班时间" @input="changed"></item-input>
                    </el-form-item>
                    <el-form-item label="主麻:" style="line-height: 38px">
                        <item-input
                            style="width: 85px"
                            :collapseTags="true"
                            type="remoteselect"
                            v-model="anesthesiologist_old"
                            :options="workoption"
                            placeholder="交班人"
                            @input="changed"
                        ></item-input>
                        <span class="el-icon-right"></span>
                        <item-input
                            style="width: 85px"
                            :collapseTags="true"
                            type="remoteselect"
                            v-model="anesthesiologist_new"
                            :options="workoption"
                            placeholder="接班人"
                            @input="changed"
                        ></item-input>
                    </el-form-item>
                    <el-form-item label="助手:" style="line-height: 38px">
                        <item-input
                            style="width: 130px"
                            :collapseTags="true"
                            type="remotemultiselect"
                            v-model="anesthesiologistAssts_old"
                            :options="workAsstsoption"
                            placeholder="交班人"
                            @input="changed"
                        ></item-input>
                        <span class="el-icon-right"></span>
                        <item-input
                            style="width: 130px"
                            :collapseTags="true"
                            type="remotemultiselect"
                            v-model="anesthesiologistAssts_new"
                            :options="workAsstsoption"
                            placeholder="接班人"
                            @input="changed"
                        ></item-input>
                    </el-form-item>
                    <el-form-item label="麻醉护士:" style="line-height: 38px">
                        <item-input
                            style="width: 130px"
                            :collapseTags="true"
                            type="remotemultiselect"
                            v-model="anes_nurse_old"
                            :options="workAnesNurseoption"
                            placeholder="交班人"
                            @input="changed"
                        ></item-input>
                        <span class="el-icon-right"></span>
                        <item-input
                            style="width: 130px"
                            :collapseTags="true"
                            type="remotemultiselect"
                            v-model="anes_nurse_new"
                            :options="workAnesNurseoption"
                            placeholder="接班人"
                            @input="changed"
                        ></item-input>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="18" :md="16">
                <DocFrame
                    ref="doc"
                    :docno="(this.$root.DOCUMENT && this.$root.DOCUMENT.SZJJ014) || 0"
                    :guid="docguid"
                    :surgeryId="surgeryId"
                    docname="术中交接"
                    @saved="afterDocSaved"
                    @changed="changed"
                ></DocFrame>
            </el-col>
            <el-col :lg="6" :md="8">
                <div v-if="handovers.length == 0">&nbsp;</div>
                <el-row v-else class="margin20 margin-none-h">
                    <!-- <h3 class="align-center">交接记录</h3> -->
                    <el-timeline class="align-left handover-nurse">
                        <el-timeline-item placement="top" type="info" :timestamp="surgeryBegin"> 手术开始 </el-timeline-item>
                        <el-timeline-item
                            placement="top"
                            v-for="(activity, index) in savedHandovers"
                            :type="active === activity.document_id ? 'primary' : 'info'"
                            :key="index"
                            :timestamp="activity.shift_time"
                        >
                            <el-card>
                                <div>主麻：{{ activity.anesthesiologist_old }}<span class="el-icon-right"></span>{{ activity.anesthesiologist_new }}</div>
                                <div>助手：{{ activity.anesthesiologistAssts_old }}<span class="el-icon-right"></span>{{ activity.anesthesiologistAssts_new }}</div>
                                <div v-show="activity.anes_nurse_old || activity.anes_nurse_new">护士：{{ activity.anes_nurse_old }}<span class="el-icon-right"></span>{{ activity.anes_nurse_new }}</div>
                                <div class="align-right padding5" v-if="activity.id > 0">
                                    <el-link type="info" @click="activeNode(activity)"><span class="el-icon-edit"></span>编辑</el-link>
                                    <el-link type="danger" @click="deleteHandover(activity)"><span class="el-icon-delete"></span>删除</el-link>
                                </div>
                                <div class="align-right padding5" v-else>
                                    <el-tag type="danger" size="mini" effect="light" v-if="activeHandover && activeHandover.unsaved">尚未保存</el-tag>
                                </div>
                            </el-card>
                        </el-timeline-item>
                        <!-- 手术结束显示手术结束标记，未结束则显示下一次交班 -->
                        <el-timeline-item placement="top" type="info" :timestamp="surgeryEnd" v-if="surgeryEnd"> 手术结束 </el-timeline-item>
                    </el-timeline>
                </el-row>
            </el-col>
        </el-row>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `HandoverAnesthesia`,
    props: {},
    data() {
        return {
            title: `麻醉交接`,
            surgeryId: this.$route.query.surgery_id,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            token: this.$route.query.token,
            surgeryInfo: undefined,
            handovers: [],
            shift_time: this.$moment(new Date()).format(`YYYY/MM/DD HH:mm:ss`),
            anesthesiologist_old: ``,
            anesthesiologist_new: ``,
            anesthesiologistAssts_old: [],
            anesthesiologistAssts_new: [],
            anes_nurse_old: [],
            anes_nurse_new: [],
            active: ``,
            zm: [],
            zs: [],
            finished: true,
            h_t: 1
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
    },
    mounted() {
        this.loadSurgery()
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.loadHandovers()
        this.$nextTick(() => {
            this.$refs[`doc`].loadDocument()
        })
    },
    computed: {
        ...mapGetters([`sysuser/workers_by_duty`, `sysuser/workers_by_dutyNew`, `currentUser`]),
        docguid() {
            return `${this.active}`
        },
        savedHandovers() {
            return _.filter(this.handovers, { unsaved: false })
        },
        activeHandover() {
            let index = _.findIndex(this.handovers, { document_id: this.active })
            this.h_t = index + 1
            return this.handovers[index]
        },
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        surgeryBegin() {
            return (this.surgeryInfo && this.surgeryInfo.in_room && this.$moment(this.surgeryInfo.in_room).format(`YYYY/MM/DD HH:mm:ss`)) || `--`
        },
        surgeryEnd() {
            return (this.surgeryInfo && this.surgeryInfo.enum_surgery_status >= 40 && this.surgeryInfo.out_room && this.$moment(this.surgeryInfo.out_room).format(`YYYY/MM/DD HH:mm:ss`)) || `--`
        },
        workoption() {
            return q => {
                let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                if (this.$root.UseASACheck == `1`) {
                    works = works.map(d => {
                        return {
                            label: d.label,
                            value: d.value,
                            jianpin: d.jianpin,
                            card_no: d.card_no,
                            worker_duty: d.worker_duty,
                            //  code: d.code,
                            // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                            code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                        }
                    })
                }
                if (q && q.keyword) {
                    return works.filter(d => {
                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                    })
                } else {
                    return works
                }
            }
        },
        workAsstsoption() {
            return q => {
                let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                let deepworkers = JSON.parse(JSON.stringify(works))
                let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                hsworkers.forEach((item, index) => {
                    let mc = _.find(deepworkers, x => x.value == item.value)
                    if (mc) {
                    } else {
                        deepworkers.push(item)
                    }
                })
                if (this.$root.UseASACheck == `1`) {
                    deepworkers = deepworkers.map(d => {
                        return {
                            label: d.label,
                            value: d.value,
                            jianpin: d.jianpin,
                            card_no: d.card_no,
                            worker_duty: d.worker_duty,
                            //  code: d.code,
                            // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                            code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                            // code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code

                        }
                    })
                }
                if (q && q.keyword) {
                    return deepworkers.filter(d => {
                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                    })
                } else {
                    return deepworkers
                }
            }
        },
        workAnesNurseoption() {
            return q => {
                console.log(`this.worker`, this.worker)
                let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                let deepworkers = JSON.parse(JSON.stringify(works))
                if (this.$root.UseASACheck == `1`) {
                    deepworkers = deepworkers.map(d => {
                        return {
                            label: d.label,
                            value: d.value,
                            jianpin: d.jianpin,
                            card_no: d.card_no,
                            worker_duty: d.worker_duty,
                            //  code: d.code,
                            // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                            code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                            // code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code

                        }
                    })
                }
                if (q && q.keyword) {
                    return deepworkers.filter(d => {
                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                    })
                } else {
                    return deepworkers
                }
            }
        }
    },
    methods: {
        loadSurgery() {
            if (!this.surgeryId) return
            let req = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
            req.then(data => {
                this.surgeryInfo = data
                // console.log(this.surgeryInfo)
            }).catch(e => console.log(e))
        },
        loadHandovers() {
            let that = this
            if (!this.surgeryId) return
            let req1 = this.myaxios.get(`/api/Nursing/ShiftWorker/Get?surgeryId=${this.surgeryId}&shiftType=1`)
            req1.then((hs) => {
                that.handovers = _.filter(hs, `id`).map(h => {
                    return {
                        // content:"手术开始",
                        shift_time: that.$moment(h.shift_time || h.modify_date).format(`YYYY/MM/DD HH:mm:ss`),
                        anesthesiologistAssts_old_v: h.anesthesiologistAssts_old,
                        anesthesiologistAssts_old: h.anesthesiologistAssts_old.map(c => c.label).toString(),
                        anesthesiologistAssts_new_v: h.anesthesiologistAssts_new,
                        anesthesiologistAssts_new: h.anesthesiologistAssts_new.map(c => c.label).toString(),
                        anesthesiologist_old_v: h.anesthesiologist_old && h.anesthesiologist_old[0],
                        anesthesiologist_old: h.anesthesiologist_old.map(c => c.label).toString(),
                        anesthesiologist_new_v: h.anesthesiologist_new && h.anesthesiologist_new[0],
                        anesthesiologist_new: h.anesthesiologist_new.map(c => c.label).toString(),
                        // 麻醉护士
                        anes_nurse_old_v: h.anes_nurse_old,
                        anes_nurse_old: h.anes_nurse_old.map(c => c.label).toString(),
                        anes_nurse_new_v: h.anes_nurse_new,
                        anes_nurse_new: h.anes_nurse_new.map(c => c.label).toString(),
                        document_id: h.document_id,
                        unsaved: false,
                        id: h.id
                    }
                })
                if (that.handovers.length == 0) {
                    that.addNewHandover()
                } else {
                    that.activeNode(_.last(this.handovers))
                }
            })
                .catch(e => {
                    console.log(e)
                })
        },
        afterDocSaved() {
            this.saveHandOver()
        },
        saveHandOver() {
            let h = this.activeHandover

            if (!this.saving) {
                this.saving = true
                let req
                if (h.id > 0) {
                    req = this.myaxios.put(`/api/Nursing/ShiftWorker/Put`, {
                        anesthesiologist_old: _.isArray(this.anesthesiologist_old) ? this.anesthesiologist_old && this.anesthesiologist_old.value : [this.anesthesiologist_old && this.anesthesiologist_old.value],
                        anesthesiologist_new: _.isArray(this.anesthesiologist_new) ? this.anesthesiologist_new && this.anesthesiologist_new.value : (this.anesthesiologist_new ? [this.anesthesiologist_new && this.anesthesiologist_new.value] : []),
                        anesthesiologistAssts_old: this.anesthesiologistAssts_old.map(d => d.value),
                        anesthesiologistAssts_new: this.anesthesiologistAssts_new.map(d => d.value),
                        anes_nurse_old: this.anes_nurse_old.map(d => d.value),
                        anes_nurse_new: this.anes_nurse_new.map(d => d.value),
                        surgery_id: this.surgeryId,
                        document_id: h.document_id,
                        shift_time: this.shift_time,
                        modify_date: this.shift_time,
                        other_text: h.order,
                        enum_shift_type: 1,
                        id: h.id
                    })
                } else {
                    req = this.myaxios.post(`/api/Nursing/ShiftWorker/Post`, {
                        anesthesiologist_old: _.isArray(this.anesthesiologist_old) ? this.anesthesiologist_old && this.anesthesiologist_old.value : [this.anesthesiologist_old && this.anesthesiologist_old.value],
                        anesthesiologist_new: _.isArray(this.anesthesiologist_new) ? this.anesthesiologist_new && this.anesthesiologist_new.value : (this.anesthesiologist_new ? [this.anesthesiologist_new && this.anesthesiologist_new.value] : []),
                        anesthesiologistAssts_old: this.anesthesiologistAssts_old.map(d => d.value),
                        anesthesiologistAssts_new: this.anesthesiologistAssts_new.map(d => d.value),
                        anes_nurse_old: this.anes_nurse_old.map(d => d.value),
                        anes_nurse_new: this.anes_nurse_new.map(d => d.value),
                        surgery_id: this.surgeryId,
                        document_id: h.document_id,
                        shift_time: this.shift_time,
                        modify_date: this.shift_time,
                        other_text: h.order,
                        enum_shift_type: 1,
                        id: h.id
                    })
                }

                req.then(data => {
                    this.finished = true
                    this.saving = false
                    this.loadHandovers()
                }).catch(e => {
                    this.finished = true
                    this.saving = false
                    console.log(e)
                })
            }
        },
        activeNode(activity) {
            if (this.activeHandover && this.activeHandover.unsaved && this.activeHandover.id !== activity.id && this.activeHandover.id > 0) {
                this.$message.warning(`尚存在未保存的交接，不允许编辑其它交接记录`)
                return
            }
            this.active = activity.document_id
            this.shift_time = activity.shift_time
            this.anesthesiologist_old = activity.anesthesiologist_old_v || ``
            this.anesthesiologist_new = activity.anesthesiologist_new_v || ``
            this.anesthesiologistAssts_old = activity.anesthesiologistAssts_old_v || []
            this.anesthesiologistAssts_new = activity.anesthesiologistAssts_new_v || []
            this.anes_nurse_old = activity.anes_nurse_old_v || []
            this.anes_nurse_new = activity.anes_nurse_new_v || []
            this.$refs.doc.loadDocument()
        },
        addNewHandover() {
            let req1 = this.myaxios.get(`/api/Nursing/ShiftWorker/GetDefault?surgeryId=${this.surgeryId}&workerDuty=3`) // 麻醉医生
            let req2 = this.myaxios.get(`/api/Nursing/ShiftWorker/GetDefault?surgeryId=${this.surgeryId}&workerDuty=4`) // 麻醉助手
            let req3 = this.myaxios.get(`/api/Nursing/ShiftWorker/GetDefault?surgeryId=${this.surgeryId}&workerDuty=8`) // 麻醉护士
            this.myaxios.all(req1, req2, req3).then(([data, data1, data2]) => {
                this.zm = data
                this.zs = data1
                this.hs = data2
                let newHandover = {
                    // content:"手术开始",
                    shift_time: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                    anesthesiologistAssts_old_v: this.zs && this.zs,
                    anesthesiologistAssts_old: this.zs && this.zs.map(d => d.label).toString(),
                    anesthesiologistAssts_new_v: [],
                    anesthesiologistAssts_new: ``,
                    anesthesiologist_old_v: this.zm && this.zm[0],
                    anesthesiologist_old: this.zm && this.zm.map(d => d.label).toString(),
                    anesthesiologist_new_v: ``,
                    anesthesiologist_new: ``,
                    anes_nurse_old_v: this.hs && this.hs,
                    anes_nurse_old: this.hs && this.hs.map(d => d.label).toString(),
                    anes_nurse_new_v: [],
                    anes_nurse_new: ``,
                    document_id: `handover_${this.surgeryId}_${this.generateUUID()}`,
                    id: 0,
                    unsaved: true
                }
                if (this.handovers.length > 0) {
                    let lastHandover = _.last(this.handovers)
                    if (lastHandover.unsaved) {
                        this.$message.warning(`尚未保存上一次交接，不允许新增交接记录`)
                        return
                    }
                    Object.assign(newHandover, {
                        anes_nurse_old_v: lastHandover.anes_nurse_new_v,
                        anes_nurse_old: lastHandover.anes_nurse_new,
                        anesthesiologistAssts_old_v: lastHandover.anesthesiologistAssts_new_v,
                        anesthesiologistAssts_old: lastHandover.anesthesiologistAssts_new,
                        anesthesiologist_old_v: lastHandover.anesthesiologist_new_v,
                        anesthesiologist_old: lastHandover.anesthesiologist_new
                    })
                }

                this.handovers.push(newHandover)
                this.activeNode(newHandover)
            })
            // req2.then(data => {

            // })
        },
        deleteHandover() {
            let handoverIndex = _.findIndex(this.handovers, { document_id: this.active })
            if (this.handovers[handoverIndex].id == 0) return
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.delete(`/api/Nursing/ShiftWorker/DeleteById?headId=${this.handovers[handoverIndex].id}`)
                req.then(data => {
                    this.handovers.splice(handoverIndex, 1)
                    if (this.handovers.length > 0) {
                        this.activeNode(_.last(this.handovers))
                    } else {
                        this.addNewHandover()
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        generateUUID() {
            var d = new Date().getTime()
            var uuid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16) % 16 | 0
                d = Math.floor(d / 16)
                return (c == `x` ? r : (r & 0x3) | 0x8).toString(16)
            })
            return uuid
        },
        clearChanges() {
            if (this.activeHandover.id > 0) {
                this.$set(this.activeHandover, `unsaved`, false)
                this.activeNode(this.activeHandover)
            } else if (this.savedHandovers.length > 0) {
                this.handovers = this.savedHandovers
                this.activeNode(_.last(this.savedHandovers))
            } else {
                this.activeNode(this.activeHandover)
            }
            this.finished = true
        },
        SaveChanges() {
            //  保存用户更改，成功刷新数据，失败不刷新
            let that = this
            let valid = true
            let anestheSiologistOldObj = this.anesthesiologist_old && this.anesthesiologist_old.value
            let anestheSiologistNewObj = this.anesthesiologist_new && this.anesthesiologist_new.value
            let anestheSiologistAsstsOldObj = this.anesthesiologistAssts_old && this.anesthesiologistAssts_old.map(d => d.value)
            let anestheSiologistAsstsNewObj = this.anesthesiologistAssts_new && this.anesthesiologistAssts_new.map(d => d.value)
            if (this.shift_time.length == 0) {
                valid = false
                this.$message.error(`交班时间不能为空`)
            } else if ((anestheSiologistOldObj == `` || anestheSiologistNewObj == ``) && (anestheSiologistAsstsOldObj.length == 0 || anestheSiologistAsstsNewObj.length == 0)) {
                valid = false
                this.$message.error(`助手不能全部为空`)
            } else if (
                (anestheSiologistOldObj.toString() == anestheSiologistNewObj.toString()) ||
                (anestheSiologistAsstsOldObj.toString() == anestheSiologistAsstsNewObj.toString() && anestheSiologistAsstsOldObj.length + anestheSiologistAsstsNewObj.length > 0)
            ) {
                valid = false
                this.$message.error(`交班与接班不能是同一个人`)
            }
            if (that.finished && valid) {
                that.finished = false
                this.$refs.doc.save()
            }
        },
        changed(changed) {
            this.$set(this.activeHandover, `unsaved`, changed)
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadHandovers()
        }
    }
}
</script>
<style scoped>
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
h3 {
    margin: 0;
}
</style>
<style  lang="less">
.handover-nurse .el-timeline-item__node {
    cursor: pointer;
    z-index: 2;
    &:hover {
        width: 20px;
        height: 20px;
        left: -6px;
        top: -6px;
        background: #409eff;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/Handover.vue